import React from "react";
import { Link } from "react-router-dom";
import { products } from "../data/mock";
import { Ticker, JoinBand, ProductCard, Reveal, Kick } from "../components/Shared";
import Seo from "../components/Seo";

export default function Home() {
  return (
    <>
      <Seo
        title="Ninja Athletic Club | Warrior Mindset Art & Hybrid Training Culture | Dallas"
        description="Ninja Athletic Club is a warrior mindset brand for hybrid athletes. Cinematic motivational wall art, HYROX training culture, recovery rituals, and ninja discipline."
        path="/"
      />
      <header className="hero">
        <div
          className="hero-bg"
          style={{ backgroundImage: "url('/images/hero-1920.webp')" }}
          role="img"
          aria-label="Lone warrior standing in mist under a shaft of light, black and white"
        ></div>
        <div className="hero-scrim"></div>
        <div className="wrap hero-in">
          <div className="kick">
            <span className="seal">忍</span>
            <span className="label">Warrior Mindset · Hybrid Sport · Dallas, TX</span>
          </div>
          <h1>
            <span className="row">Discipline is</span>
            <span className="row">
              <span className="ol">the weapon.</span>
            </span>
          </h1>
          <p className="sub">
            Cinematic art, training culture, and ninja philosophy for hybrid athletes. Built for the ones who show
            up when nobody is watching.
          </p>
          <div className="cta-row">
            <Link className="btn wh" to="/shop">
              Shop the Art
            </Link>
            <a className="btn ol" href="#hub">
              Enter the Dojo
            </a>
          </div>
          <p className="born label">One word. One code. NinjAthletiClub.</p>
        </div>
      </header>

      <Ticker />

      <section id="art">
        <div className="wrap">
          <div className="arthead">
            <Reveal>
              <Kick k="刀">Drop 001</Kick>
              <h2 className="sec">The art of war, framed.</h2>
              <p className="lede">
                Gallery-grade prints forged from warrior philosophy. Every piece carries the club seal. Hover to see
                the raw artwork.
              </p>
            </Reveal>
            <Link className="cutlink" to="/shop">
              View Full Collection
            </Link>
          </div>

          <div className="grid3">
            {products.filter((p) => p.drop === "001").map((p, i) => (
              <ProductCard key={p.slug} p={p} delay={`d${i + 1}`} />
            ))}
          </div>
        </div>
      </section>

      <section id="hub">
        <div className="wrap">
          <Reveal>
            <Kick k="道">The Way</Kick>
            <h2 className="sec">Train the body. Forge the mind.</h2>
            <p className="lede" style={{ marginBottom: 52 }}>
              The club is more than art on a wall. It is a code. Three disciplines, practiced daily.
            </p>
          </Reveal>

          <div className="grid3">
            <Reveal as="article" className="pillar" delay="d1">
              <div className="pseal">体</div>
              <h3>Train</h3>
              <p>
                Hybrid engine work. HYROX culture, run plus strength programming philosophy, and the mentality of
                race day. What it takes to be dangerous at everything.
              </p>
              <Link className="cutlink" to="/train">
                Enter Training
              </Link>
            </Reveal>
            <Reveal as="article" className="pillar" delay="d2">
              <div className="pseal">息</div>
              <h3>Recover</h3>
              <p>
                The warrior rests with intent. Heat, cold, breath, and sleep as rituals. Recovery culture and the
                habits that let you go to battle again tomorrow.
              </p>
              <Link className="cutlink" to="/recover">
                Enter Recovery
              </Link>
            </Reveal>
            <Reveal as="article" className="pillar" delay="d3">
              <div className="pseal">心</div>
              <h3>Mindset</h3>
              <p>
                Bushido, aikido, and the discipline codes of history's greatest warriors, translated for the modern
                athlete. Musashi did not have rest days from the mind.
              </p>
              <Link className="cutlink" to="/mindset">
                Enter Mindset
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <section id="family" className="onpaper">
        <div className="wrap">
          <Reveal>
            <Kick k="家" dark>
              The Family
            </Kick>
            <h2 className="sec">Three houses. One code.</h2>
            <p className="lede">
              Ninja Athletic Club runs with NinjAthlete and NinjaRunClub. Same blood, different weapons.
            </p>
          </Reveal>

          <div className="split">
            <Reveal as="article" className="house" delay="d1">
              <p className="tag">The Lab</p>
              <h3>NinjAthlete</h3>
              <p>
                The science side of the family. Verified research, longevity protocols, recovery data, and the HYROX
                gym directory. When you need evidence, go to the lab.
              </p>
              <a className="cutlink" href="https://ninjathlete.com" rel="noopener noreferrer" target="_blank">
                Visit NinjAthlete
              </a>
            </Reveal>
            <Reveal as="article" className="house dojo" delay="d2">
              <p className="tag">The Dojo</p>
              <h3>Ninja Athletic Club</h3>
              <p>
                The soul side. Warrior philosophy, cinematic art for your walls, training culture, and the daily code
                of discipline. When you need fire, come to the dojo.
              </p>
              <Link className="cutlink" to="/shop">
                Shop the Art
              </Link>
            </Reveal>
            <Reveal as="article" className="house" delay="d3">
              <p className="tag">The Road</p>
              <h3>NinjaRunClub</h3>
              <p>
                The running arm of the family. Road miles, run culture, and the community that logs them together.
                When you need the miles, hit the road.
              </p>
              <a className="cutlink" href="https://ninjarunclub.com" rel="noopener noreferrer" target="_blank">
                Visit NinjaRunClub
              </a>
            </Reveal>
          </div>
        </div>
      </section>

      <JoinBand />
    </>
  );
}
